<template>
  <div class="cgv-container">
    <h1 class="cgv-title">CONDITIONS GENERALES D’UTILISATION QUERY JURISTE</h1>
    <div class="warning-box">
      <p>
        QUERY JURISTE ne fournit aucune garantie sur l’exactitude et la pertinence des Contenus Générés par la Plateforme. Il appartient au Client et à l’Utilisateur de vérifier la qualité des Contenus Générés avant de les utiliser. La responsabilité de QUERY JURISTE ne saurait être engagée en cas de différend entre le Client ou l’Utilisateur et leurs clients.
      </p>
    </div>

    <section class="cgv-section">
      <h2>Identification de QUERY JURISTE</h2>
      <p>La société QUERY JURISTE (« QUERY JURISTE ») est une société à responsabilité limitée inscrite au RCS de Paris sous le n° 929 322 261, dont le siège social est situé 37 rue Rousselet, 75007 Paris.</p>
      <p>QUERY JURISTE peut être contactée à l’adresse e-mail suivante : <a href="mailto:contact@query-juriste.com">contact@query-juriste.com</a>.</p>
    </section>

    <section class="cgv-section">
      <h2>Définitions</h2>
      <p>Aux fins des présentes :</p>
      <ul class="definitions-list">
        <li><strong>« Clients »</strong> désigne les clients professionnels du droit (avocats et juristes d’entreprise notamment) ayant accès aux Services via la Plateforme.</li>
        <li><strong>« Compte Client »</strong> désigne le compte ouvert au nom du Client après vérification de son adresse e-mail et réception du mail de confirmation de QUERY JURISTE, permettant l’accès aux Services.</li>
        <li><strong>« Compte Utilisateur »</strong> désigne le compte personnel créé au nom d’une personne physique (collaborateur, stagiaire, etc.) autorisée par le Client, lui permettant d’accéder à la Plateforme et aux Services sous la responsabilité dudit Client.</li>
        <li><strong>« Conditions Générales »</strong> désigne les présentes conditions générales d’utilisation et de fourniture des Services.</li>
        <li><strong>« Contenus Générés »</strong> désignent l’ensemble des textes, réponses, analyses, et autres informations produits et fournis par la Plateforme en réponse aux requêtes des Utilisateurs.</li>
        <li><strong>« Devis »</strong> désigne la proposition commerciale adressée par QUERY JURISTE au Client en vue de la souscription aux Services, précisant notamment les conditions financières, la durée d’engagement et le nombre de Licences Utilisateur.</li>
        <li><strong>« Données d’Utilisation »</strong> désignent, ensemble, les Questions et les Contenus Générés.</li>
        <li><strong>« Licence Utilisateur »</strong> désigne le droit non exclusif et non cessible accordé par QUERY JURISTE à un Utilisateur unique d’accéder à la Plateforme et d’utiliser les Services, sous la responsabilité du Client et conformément aux Conditions Générales.</li>
        <li><strong>« Plateforme »</strong> désigne la plateforme éditée et exploitée par QUERY JURISTE et accessible depuis le site <a href="https://www.query-juriste.com/" target="_blank">https://www.query-juriste.com/</a>.</li>
        <li><strong>« Questions »</strong> désigne l’ensemble des requêtes, instructions, prompts, textes et données saisis ou soumis par le Client ou les Utilisateurs sur la Plateforme aux fins de l'utilisation des Services.</li>
        <li><strong>« Réglementation applicable »</strong> désigne la règlementation applicable aux données à caractère personnel et en particulier au Règlement Général sur la Protection des Données (règlement UE 2016/679 du Parlement européen et du Conseil du 27 avril 2016) et à la loi relative à l’Informatique et aux Libertés du 6 janvier 1978 dans sa dernière version en vigueur.</li>
        <li><strong>« Services »</strong> désigne ensemble, tels que décrits à l’article « Description des Services » :
          <ul>
            <li>La mise à disposition d’une solution d’assistance juridique virtuelle proposée par QUERY JURISTE sur la Plateforme, permettant notamment, au moyen de technologies d’intelligence artificielle, de générer des réponses aux questions juridiques des Utilisateurs, d’effectuer des recherches documentaires, et de fournir l’accès à une base de décisions juridiques ;</li>
            <li>Les services de maintenance et d’hébergement associés.</li>
          </ul>
        </li>
        <li><strong>« Utilisateurs »</strong> désigne toute personne physique (collaborateur, stagiaire, etc.) employée ou autorisée par le Client, qui accède à la Plateforme et aux Services à l’aide de leurs identifiants de connexion personnels et sous la responsabilité du Client.</li>
      </ul>
    </section>

    <section class="cgv-section">
      <h2>Objet</h2>
      <p>QUERY JURISTE édite et exploite la Plateforme à travers laquelle elle propose à ses Clients une solution d’assistance juridique virtuelle permettant, notamment au moyen de bases de données spécialisées et de technologies d’intelligence artificielle, de générer des réponses aux questions du Client.</p>
      <p>Les Conditions Générales ont pour objet de définir les modalités et conditions d’utilisation des Services proposés sur la Plateforme ainsi que les droits et obligations des parties dans ce cadre.</p>
      <p>Avant toute souscription, le Client reconnaît qu’il peut prendre connaissance, sur la Plateforme, des caractéristiques des Services et de leurs contraintes, notamment techniques.</p>
    </section>

    <section class="cgv-section">
      <h2>Accès à la Plateforme et aux Services</h2>

      <h3>Capacité juridique</h3>
      <p>La Plateforme et les Services sont accessibles :</p>
      <ul>
        <li>A toute personne physique disposant de la pleine capacité juridique. La personne physique qui ne dispose pas de la pleine capacité juridique ne peut accéder à la Plateforme et aux Services qu’avec l’accord de son représentant légal.</li>
        <li>A toute personne morale agissant par l’intermédiaire d’une personne physique disposant du pouvoir ou de l’habilitation requise pour contracter au nom du Client et pour son compte.</li>
      </ul>

      <h3>Plateforme et Services destinés aux professionnels</h3>
      <p>La Plateforme et les Services s’adressent exclusivement à toutes personnes physiques ou morales agissant à des fins entrant dans le cadre de son activité commerciale, industrielle, artisanale, libérale ou agricole, y compris lorsqu'elle agit au nom ou pour le compte d'un autre professionnel.</p>

      <h3>Acceptation des Conditions Générales</h3>
      <p>Le Client accepte les Conditions Générales en cochant une case dans le formulaire d’inscription. S’il n’accepte pas l’intégralité des Conditions Générales, il ne peut pas accéder aux Services.</p>
      <p>Lorsque la souscription aux Services fait l'objet d'un Devis, l’acceptation du Devis vaut acceptation expresse et sans réserve des Conditions Générales, qui y sont jointes ou rendues accessibles par un lien hypertexte.</p>
      <p>Dans tous les cas, cette acceptation ne peut être que pleine et entière. Toute acceptation sous réserve est considérée comme nulle et non avenue. Le Client qui n'accepte pas d'être lié par les Conditions Générales ne doit pas souscrire aux Services.</p>
      <p>Les Conditions Générales peuvent être complétées le cas échéant par des conditions d’utilisation particulières à certains Services, notamment lorsque les Services sont souscrits par le biais d’un Devis, lesquelles complètent les présentes Conditions Générales et, en cas de contradiction, prévalent sur ces dernières.</p>

      <h3>Inscription sur la Plateforme</h3>
      <p>Le Client peut accéder à la Plateforme et aux Services en allant directement sur la Plateforme.</p>
      <p>Pour souscrire les Services, le Client doit remplir le formulaire prévu à cet effet sur la Plateforme.</p>
      <p>Le Client doit communiquer à QUERY JURISTE l’ensemble des informations marquées comme obligatoires.</p>
      <p>L’inscription entraîne automatiquement l’ouverture du Compte Client qui lui permet d’accéder aux Services à l’aide de son identifiant de connexion et de son mot de passe.</p>
      <p>Une fois le Compte Client créé, il peut librement créer des accès pour les Utilisateurs dans la limite du nombre prévu dans les Services souscrits.</p>
      <p>Le Client est seul responsable de la création des accès pour les Utilisateurs et de leur utilisation personnelle de la Plateforme.</p>

      <h3>Gestion des Licences Utilisateur</h3>
      <p>Le nombre de Licences Utilisateur auquel le Client a droit est défini dans le Devis ou au moment de la souscription en ligne.</p>
      <p>Le Client peut, à tout moment durant une Période d’Abonnement, souscrire à des Licences Utilisateur additionnelles. Le prix de ces licences sera calculé au prorata de la durée restante de la Période en cours.</p>
      <p>Le Client a la faculté de réduire le nombre de Licences Utilisateur pour la Période d’Abonnement suivante, sous réserve de notifier sa décision à QUERY JURISTE avant la date de renouvellement tacite, conformément à l’article « Fin des Services ». Aucune réduction du nombre de licences ne peut prendre effet en cours de Période.</p>
    </section>

    <section class="cgv-section">
      <h2>Description des Services</h2>

      <h3>Services d’assistance et de génération de contenus</h3>
      <p>Le Client a accès aux Services décrits sur la Plateforme ou, le cas échéant, dans le Devis.</p>
      <p>Le Client peut notamment accéder aux Services qui suivent :</p>
      <ul>
        <li>Recherche juridique approfondie sur la base de documents juridiques pertinents ;</li>
        <li>Génération de rapports structurés avec sourcing ;</li>
        <li>Génération de contenus juridiques (analyses, synthèses) ;</li>
        <li>Accès à l’historique des recherches ;</li>
        <li>Support technique selon les modalités prévues.</li>
      </ul>
      <p>Toute demande de modification des Services souscrits devra faire l’objet d’une nouvelle souscription ou, le cas échéant, d’un devis complémentaire.</p>

      <h3>Maintenance</h3>
      <p>Le Client bénéficie pendant la durée des Services d’une maintenance, notamment corrective et évolutive. Dans ce cadre, l’accès à la Plateforme peut être limité ou suspendu.</p>
      <p>Concernant la maintenance corrective, QUERY JURISTE fait ses meilleurs efforts pour fournir au Client une maintenance corrective afin de corriger tout dysfonctionnement ou bogue relevé sur la Plateforme.</p>
      <p>Concernant la maintenance évolutive, le Client bénéficie pendant la durée des Services d’une maintenance évolutive, que QUERY JURISTE pourra réaliser automatiquement et sans information préalable, et qui comprend des améliorations des fonctionnalités de la Plateforme, l’ajout de nouvelles fonctionnalités et/ou installations techniques utilisées dans le cadre de la Plateforme (visant à introduire des extensions mineures ou majeures).</p>
      <p>L’accès à la Plateforme peut par ailleurs être limité ou suspendu pour des raisons de maintenance planifiée, qui peut inclure les opérations de maintenance corrective et évolutive susvisées.</p>

      <h3>Hébergement de la Plateforme</h3>
      <p>QUERY JURISTE assure, dans les termes d’une obligation de moyens, l’hébergement de la Plateforme, ainsi que des données produites et/ou saisies par/sur la Plateforme, sur ses serveurs ou par l’intermédiaire d’un prestataire d’hébergement professionnel.</p>
      <p>Dans ce cadre, QUERY JURISTE s’engage à fournir au Client des capacités de stockage et de traitement suffisantes dans le cadre des Services.</p>
      <p>QUERY JURISTE s’engage à mettre en œuvre l’ensemble des moyens techniques, conformes à l’état de l’art, nécessaires pour assurer la sécurité et l’accès à la Plateforme, portant sur la protection et la surveillance des infrastructures, le contrôle de l’accès physique et/ou immatériel auxdites infrastructures, ainsi que sur la mise en œuvre des mesures de détection, de prévention et de récupération pour protéger les serveurs d’actes malveillants.</p>
      <p>QUERY JURISTE s’engage également à prendre toutes précautions utiles, au regard de la nature des données et des risques présentés par les traitements automatisés de données mis en œuvre pour les besoins des Services, pour préserver la sécurité des données, et notamment empêcher qu’elles soient déformées, endommagées ou que des tiers non autorisés y aient accès.</p>

      <h3>Assistance technique</h3>
      <p>En cas de difficulté rencontrée lors de l’utilisation des Services, le Client peut contacter QUERY JURISTE à l’adresse email suivante : <a href="mailto:contact@query-juriste.com">contact@query-juriste.com</a>.</p>
      <p>Le service d’assistance technique est accessible du lundi au vendredi, hors jours chômés ou fériés, de 9 heures à 18 heures. En fonction du besoin identifié, QUERY JURISTE estimera le délai de réponse et en tiendra le Client informé.</p>

      <h3>Autres Services</h3>
      <p>QUERY JURISTE se réserve la possibilité de proposer tout autre Service qu’elle jugera utile, sous une forme et selon les fonctionnalités et moyens techniques qu’elle estimera les plus appropriés pour rendre lesdits Services.</p>
    </section>

    <section class="cgv-section">
      <h2>Durée de souscription aux Services</h2>
      <p>Les Services sont souscrits sous forme d’abonnement (l’« Abonnement »).</p>
      <p>L’Abonnement débute au jour de sa souscription pour une période initiale indiquée sur la Plateforme ou le cas échéant sur le Devis.</p>
      <p>Il se renouvelle tacitement, pour des périodes successives de même durée que la période initiale (avec la période initiale, les « Périodes »), de date à date, sauf si l’Abonnement est dénoncé dans les conditions de l’article « Fin des Services ».</p>

      <h2>Conditions financières</h2>
      <h3>Prix</h3>
      <p>Les prix des Services auxquels le Client a souscrit sont indiqués sur la Plateforme ou, le cas échéant, dans le Devis.</p>
      <p>QUERY JURISTE est libre de proposer des offres promotionnelles ou des réductions de prix.</p>
      <p>Sauf indication contraire, notamment sur devis, le prix des Services est exprimé en euros et hors taxes.</p>
      <p>Les prix de QUERY JURISTE peuvent être révisés à tout moment dans les conditions de l’article « Modification des Conditions Générales ».</p>

      <h3>Modalités de paiement et facturation</h3>
      <p>Sauf mention contraire dans le Devis, QUERY JURISTE adressera des factures par Période au Client par tout moyen utile.</p>
      <p>Le paiement de l’Abonnement s’effectue par carte bancaire à travers le service de paiement sécurisé en ligne précisé sur la Plateforme de QUERY JURISTE ou par tout moyen précisé dans le Devis, le cas échéant.</p>
      <p>Le Client garantit QUERY JURISTE qu’il dispose des autorisations nécessaires pour procéder au paiement du Prix.</p>

      <h3>Retards et défauts de paiement</h3>
      <p>Le Client est informé et accepte expressément que tout retard de paiement de tout ou partie d’une somme due à QUERY JURISTE à son échéance entraînera automatiquement, et dès le jour suivant la date de règlement figurant sur la facture :</p>
      <ul>
        <li>La déchéance du terme de l’ensemble des sommes dues par le Client et leur exigibilité immédiate, quelles que soient les modalités de règlement qui avaient été prévues ;</li>
        <li>La suspension immédiate des Services et de l’accès à la Plateforme jusqu’au complet paiement de l’intégralité des sommes dues ;</li>
        <li>La facturation au profit de QUERY JURISTE d’un intérêt de retard, dû par le seul fait de l’échéance du terme contractuel, au taux de 3 fois le taux d’intérêt légal, assis sur le montant de la créance non réglée à l’échéance et d’une indemnité forfaitaire de 40 euros au titre des frais de recouvrement, sans préjudice d’une indemnisation complémentaire si les frais de recouvrement effectivement exposés sont supérieurs à ce montant.</li>
      </ul>
    </section>

    <section class="cgv-section">
      <h2>Obligations, responsabilité et garanties du Client</h2>
      <p>Sans préjudice des autres obligations prévues aux Conditions Générales, le Client s’engage à respecter les obligations qui suivent :</p>

      <h3>Gestion du Compte Client et sécurité</h3>
      <p>Le Client :</p>
      <ul>
        <li>garantit que les informations transmises dans le formulaire d’inscription sont exactes et s’engage à les mettre à jour,</li>
        <li>reconnait que ces informations valent preuve de son identité et l’engagent dès leur validation,</li>
        <li>est responsable du maintien de la confidentialité et de la sécurité de son identifiant et mot de passe. Tout accès à la Plateforme à l’aide de ces derniers étant réputé effectué par lui.</li>
      </ul>
      <p>Le Client doit immédiatement contacter QUERY JURISTE aux coordonnées mentionnées à l’article « Identification de QUERY JURISTE » s’il constate que son Compte Client a été utilisé à son insu. Il reconnait que QUERY JURISTE aura le droit de prendre toutes mesures appropriées en pareil cas.</p>

      <h3>Utilisation conforme des Services</h3>
      <p>Le Client s’engage, dans son usage des Services et de la Plateforme, à respecter les lois et règlements en vigueur, et à ne pas porter atteinte aux droits de tiers ou à l’ordre public.</p>
      <p>Le Client reconnaît avoir pris connaissance sur la Plateforme des caractéristiques et contraintes, notamment techniques, de l’ensemble des Services. Il est seul responsable de son utilisation de la Plateforme et des Services.</p>
      <p>Le Client est informé et accepte que la mise en œuvre des Services et l’accès à la Plateforme nécessitent qu’il soit connecté à internet et que la qualité des Services dépend directement de cette connexion, dont il est seul responsable.</p>
      <p>Le Client est responsable de son utilisation des Services et de toute information qu’il partage dans ce cadre. Il est également responsable de l’utilisation des Services et de toutes informations partagées par les Utilisateurs. Il s'engage à ce que les Services soient exclusivement utilisés par lui et/ou les Utilisateurs, qui sont soumis aux mêmes obligations que lui dans leur utilisation des Services.</p>

      <p>Le Client s’interdit de détourner les Services à des fins autres que celles pour lesquelles ils ont été conçus, et notamment pour :</p>
      <ul>
        <li>exercer une activité illégale ou frauduleuse,</li>
        <li>porter atteinte à l’ordre public et aux bonnes mœurs,</li>
        <li>porter atteinte à des tiers ou à leurs droits, de quelque manière que ce soit,</li>
        <li>violer une disposition contractuelle, législative ou règlementaire,</li>
        <li>exercer toute activité de nature à interférer dans le système informatique d’un tiers notamment aux fins d’en violer l’intégrité ou la sécurité,</li>
        <li>effectuer des manœuvres visant à promouvoir ses services et/ou sites ou ceux d’un tiers,</li>
        <li>aider ou inciter un tiers à commettre un ou plusieurs actes ou activités listés ci-dessus.</li>
      </ul>

      <p>Le Client s’interdit également de :</p>
      <ul>
        <li>copier, modifier ou détourner tout élément appartenant à QUERY JURISTE ou tout concept qu’elle exploite dans le cadre des Services,</li>
        <li>adopter tout comportement de nature à interférer avec ou détourner les systèmes informatiques de QUERY JURISTE ou porter atteinte à ses mesures de sécurité informatique,</li>
        <li>porter atteinte aux droits et intérêts financiers, commerciaux ou moraux de QUERY JURISTE,</li>
        <li>commercialiser, transférer ou donner accès de quelque manière que ce soit aux Services, aux informations hébergées sur la Plateforme ou à tout élément appartenant à QUERY JURISTE.</li>
      </ul>

      <h3>Contenus et données fournis</h3>
      <p>Le Client est seul responsable des documents, éléments, données, informations et tout contenu qu’il fournit à QUERY JURISTE. Il garantit à QUERY JURISTE qu’il est habilité à lui fournir ces éléments et qu’il dispose de tous les droits et autorisations nécessaires à leur exploitation dans le cadre des Services.</p>
      <p>Il est également seul responsable de leur exactitude, de leur sincérité et de leur exhaustivité, QUERY JURISTE ne pouvant en aucun cas être tenue responsable des éventuelles erreurs, coquilles ou omissions dans les données du Client traitées, en ce compris des conséquences desdites erreurs sur les Services fournis et sur les Contenus Générés.</p>
      <p>De manière générale, la Plateforme génère automatiquement des contenus à partir des éléments communiqués par le Client. Par conséquent, QUERY JURISTE ne pourra pas être tenue responsable de l’exactitude ou de la pertinence des Contenus Générés sur la base des éléments communiqués par le Client, et ne fournit aucune garantie à cet égard.</p>

      <h3>Responsabilité professionnelle</h3>
      <p>Le Client reconnaît que les Services lui offrent une solution supplémentaire, non alternative, d’assistance juridique, et que cette solution ne saurait se substituer aux autres moyens dont le Client peut disposer par ailleurs pour atteindre les mêmes objectifs. La responsabilité finale de l'utilisation des Contenus Générés dans le cadre de leur pratique professionnelle appartient exclusivement au Client et aux Utilisateurs.</p>

      <h3>Garanties</h3>
      <p>Le Client garantit QUERY JURISTE contre toutes plaintes, réclamations, actions et/ou revendications quelconques qu’elle pourrait subir du fait de la violation, par le Client de l’une quelconque de ses obligations ou garanties aux termes des présentes Conditions Générales.</p>
      <p>Le Client s’engage à indemniser QUERY JURISTE de tout préjudice qu’elle subirait et à lui payer tous les frais, charges et/ou condamnations qu’elle pourrait avoir à supporter de ce fait.</p>
    </section>

    <section class="cgv-section">
      <h2>Obligations et responsabilités de QUERY JURISTE</h2>

      <h3>Fourniture des Services</h3>
      <p>QUERY JURISTE fait ses meilleurs efforts pour fournir au Client des Services de qualité. A cette fin, elle procède régulièrement à des contrôles afin de vérifier le fonctionnement et l’accessibilité de ses Services et peut ainsi réaliser une maintenance dans les conditions précisées à l’article « Maintenance ».</p>
      <p>QUERY JURISTE n’est néanmoins pas responsable des difficultés ou impossibilités momentanées d’accès à ses Services qui auraient pour origine :</p>
      <ul>
        <li>des circonstances extérieures à son réseau (et notamment la défaillance partielle ou totale des serveurs du Client),</li>
        <li>de la défaillance d’un équipement, d’un câblage, de services ou de réseaux non inclus dans ses Services, ou qui n’est pas sous sa responsabilité,</li>
        <li>de l’interruption des Services du fait des opérateurs télécoms ou fournisseurs d’accès à internet,</li>
        <li>de l’intervention du Client notamment via une mauvaise configuration appliquée sur les Services,</li>
        <li>d’un cas de force majeure.</li>
      </ul>
      <p>Les Services sont fournis par QUERY JURISTE tels quels et sans garantie d’aucune sorte, expresse ou implicite. QUERY JURISTE ne garantit notamment pas au Client (i) que les Services, soumis à une recherche constante pour en améliorer notamment la performance et le progrès, seront totalement exempts d’erreurs, de vices ou défauts, (ii) que les Services, étant standards et nullement proposés à la seule intention d’un Client donné en fonction de ses propres contraintes personnelles, répondront spécifiquement à ses besoins et attentes.</p>
      <p>QUERY JURISTE ne propose aucune garantie de niveau de service de la Plateforme.</p>
      <p>Toutefois, QUERY JURISTE fait ses meilleurs efforts pour maintenir un accès à la Plateforme 24h/24h et 7j/7j sauf en cas de maintenance planifiée dans les conditions définies à l’article « Maintenance » ou de force majeure.</p>

      <h3>Confidentialité et sécurité</h3>
      <p>QUERY JURISTE s’engage à n’utiliser les informations, documents, données et plus généralement tous les éléments qui pourront lui être transmis dans le cadre de l’utilisation de la Plateforme et des Services qu’aux fins d’exécution des présentes et afin d’améliorer ses services, et à ne pas les diffuser ou partager avec quelque tiers que ce soit pour d’autres finalités, sauf demande ou accord exprès du Client.</p>
      <p>QUERY JURISTE reconnaît et accepte expressément que ces documents, éléments, données et informations sont des informations confidentielles.</p>
      <p>Cette obligation de confidentialité ne s’étend pas aux documents et informations :</p>
      <ul>
        <li>dont QUERY JURISTE avait déjà connaissance ;</li>
        <li>déjà publics lors de leur communication ou qui le deviendraient sans violation des Conditions Générales ;</li>
        <li>qui auraient été reçus d’un tiers de manière licite ;</li>
        <li>dont la communication serait exigée par les autorités judiciaires, en application des lois et règlements ou en vue d’établir les droits de QUERY JURISTE au titre des Conditions Générales.</li>
      </ul>
      <p>QUERY JURISTE fait ses meilleurs efforts pour sauvegarder toutes données produites et/ou saisies par/sur la Plateforme.</p>
      <p>Sauf en cas de fautes avérées de la part de QUERY JURISTE, elle n’est néanmoins pas responsable de toute perte de données au cours des opérations de maintenance.</p>
      <p>QUERY JURISTE s’engage à faire ses meilleurs efforts pour assurer la sécurité de la Plateforme.</p>
      <p>La responsabilité de QUERY JURISTE ne saurait toutefois être engagée en cas d’introduction malveillante sur le Compte Client dès lors qu’il n’est pas démontré que les mesures de sécurité qu’elle a mises en place étaient gravement défaillantes.</p>
      <p>En outre, QUERY JURISTE ne saurait être tenue responsable de tout manque de vigilance de la part du Client dans le maintien de la confidentialité de leur identifiant et de leur mot de passe.</p>

      <h3>Limitation de responsabilité</h3>
      <div class="warning-box">
        <p>La Plateforme étant basée sur des grands modèles de langage (LLM), le Client reconnaît et accepte que QUERY JURISTE ne peut garantir que la Plateforme sera en mesure de répondre à l’ensemble des besoins du Client ni que les Contenus Générés sont exempts d'hallucinations, de biais ou d'erreurs factuelles inhérentes à la technologie. La responsabilité de QUERY JURISTE ne pourra être engagée à ce titre.</p>
      </div>
      <p>QUERY JURISTE n’est pas partie aux relations entre le Client et ses clients et ne saurait en aucun cas voir sa responsabilité engagée au titre des éventuelles difficultés liées à ces relations, ni être partie à quelques litiges éventuels que ce soit, concernant notamment les opérations, les garanties, déclarations et autres obligations quelconques auxquelles le Client serait tenu.</p>
      <p>Hors cas de manquement avéré de QUERY JURISTE à ses obligations, le Client s’oblige à mettre QUERY JURISTE hors de cause dans tous différends ou litiges avec lesdites personnes et à faire son affaire personnelle de leur résolution.</p>
      <p>QUERY JURISTE ne pourra être tenue responsable des décisions prises par le Client ou par tout tiers désigné par lui.</p>

      <h3>Plafond de responsabilité</h3>
      <p>En tout état de cause, la responsabilité susceptible d’être encourue par QUERY JURISTE au titre des présentes est expressément limitée aux seuls dommages directs avérés subis par le Client et sera expressément limitée au montant total du prix perçu par QUERY JURISTE au titre des présentes pendant les 12 mois précédant le fait générateur de responsabilité.</p>

      <h3>Sites et sources tiers</h3>
      <p>Des liens hypertextes accessibles depuis la Plateforme peuvent renvoyer vers d’autres sites ou d’autres sources Internet. QUERY JURISTE n’étant pas en mesure de contrôler ces sites et ces sources externes, le Client reconnaît que QUERY JURISTE n’assume aucune responsabilité quant aux contenus, publicités, produits, services ou autre matériel disponibles sur ou à partir de ces sites ou sources externes.</p>
      <p>Le Client reconnaît par ailleurs que QUERY JURISTE ne pourra être tenu responsable de toute perte ou dommage en relation avec l’utilisation de contenus, biens ou services, disponibles sur ces sites ou sources externes. QUERY JURISTE ne saurait non plus être tenu responsable dans le cas où le contenu desdits sites contreviendrait aux dispositions légales ou réglementaires en vigueur. Toute erreur ou tout contenu illicite provenant desdits sites doit être signalé à QUERY JURISTE.</p>

      <h3>Sous-traitance et cession</h3>
      <p>QUERY JURISTE peut recourir à des sous-traitants dans le cadre de l’exécution des Services, qui sont soumis aux mêmes obligations que les siennes dans le cadre de leur intervention. Elle reste néanmoins seule responsable de la bonne exécution des Services à l’égard du Client.</p>
      <p>QUERY JURISTE peut se substituer toute personne qui sera subrogée dans tous ses droits et obligations au titre de sa relation contractuelle avec le Client. Le cas échéant, elle informera le Client de cette substitution par tout moyen écrit.</p>
    </section>

    <section class="cgv-section">
      <h2>Propriété intellectuelle</h2>

      <h3>Droits sur la Plateforme</h3>
      <p>La Plateforme est la propriété de QUERY JURISTE, de même que les systèmes, logiciels, structures, infrastructures, bases de données, codes et contenus de toute nature (textes, images, visuels, logos, marques, bases de données, etc.) exploités par QUERY JURISTE sur la Plateforme. Ils sont protégés par tous droits de propriété intellectuelle ou droits des producteurs de bases de données en vigueur. La licence que QUERY JURISTE consent au Client n’entraine aucun transfert de propriété.</p>
      <p>Le Client, et les Utilisateurs, bénéficient d’une licence en mode SaaS non exclusive et non transmissible d’utilisation de la Plateforme pour la durée prévue à l’article « Durée de souscription aux Services ».</p>
      <p>Tous désassemblages, décompilations, décryptages, extractions, réutilisations, copies et plus généralement, tous actes de reproduction, représentation, diffusion et utilisation de l’un quelconque de ces éléments, en tout ou partie, sans l’autorisation de QUERY JURISTE sont strictement interdits et pourront faire l’objet de poursuites judiciaires.</p>

      <h3>Droits sur les Données d’Utilisation</h3>
      <p>Le Client conserve l'entière propriété et la titularité de tous les droits de propriété intellectuelle afférents aux Questions qu'il soumet sur la Plateforme.</p>
      <p>Sous réserve du parfait paiement du prix des Services, QUERY JURISTE cède au Client l'intégralité des droits de propriété intellectuelle applicables sur les Contenus Générés à compter de leur création.</p>
      <p>Le Client est libre d'utiliser, de modifier, de reproduire et de diffuser les Contenus Générés pour les besoins de son activité professionnelle.</p>
      <p>Cette cession ne concerne que les Contenus Générés et n'emporte aucune cession des droits de QUERY JURISTE sur la Plateforme, ses logiciels, algorithmes, et autres éléments décrits au présent article, qui restent sa propriété exclusive.</p>
      <p>Le Client concède à QUERY JURISTE une licence mondiale, non exclusive, gratuite et transférable d'utilisation, de reproduction, de modification et de traitement des Données d'Utilisation, aux fins de (i) fournir les Services au Client conformément aux présentes, (ii) assurer la maintenance et la sécurité de la Plateforme, et (iii) améliorer les fonctionnalités des Services.</p>
    </section>

    <section class="cgv-section">
      <h2>Modes de preuve admis</h2>
      <p>La preuve peut être établie par tout moyen.</p>
      <p>Le Client est informé que les messages échangés par le biais de la Plateforme ainsi que les données recueillies sur la Plateforme et les équipements informatiques de QUERY JURISTE constituent l’un des modes de preuve admis, notamment pour démontrer la réalité des Services réalisés et le calcul de leur prix.</p>
    </section>

    <section class="cgv-section">
      <h2>Données à caractère personnel</h2>

      <h3>Dispositions générales</h3>
      <p>L’objet de cette clause est de définir les conditions selon lesquelles QUERY JURISTE entreprend, au nom du Client, le traitement de données personnelles décrit ci-dessous.</p>
      <p>QUERY JURISTE et le Client s’engagent, chacun pour ce qui le concerne, à se conformer à la Réglementation Applicable.</p>

      <h3>Description du traitement sous-traité</h3>
      <p>Dans le cadre des Services, QUERY JURISTE est amenée à traiter des données à caractère personnel au nom et pour le compte du Client en qualité de sous-traitant, tandis que le Client agit en qualité de responsable de traitement au sens de la Réglementation applicable. Les caractéristiques des traitements sont décrites en Annexe 1 des Conditions Générales.</p>

      <h3>Obligations de QUERY JURISTE vis-à-vis du Client</h3>

      <p><strong>Traitement des données :</strong></p>
      <p>QUERY JURISTE s’engage à ne traiter les données à caractère personnel qu’aux fins des finalités listées à l’Annexe 1 et conformément aux instructions documentées du Client, y compris en ce qui concerne le transfert des données en dehors de l’Union Européenne. QUERY JURISTE s’engage à informer le Client si, selon lui, une instruction constitue une violation de la Réglementation applicable. En outre, si QUERY JURISTE est tenue de procéder à un transfert de données vers un pays tiers ou à une organisation internationale, en vertu du droit applicable aux Conditions Générales, elle doit informer le Client de cette obligation juridique avant le traitement, sauf si le droit concerné interdit une telle information pour des motifs importants d’intérêt public.</p>

      <p><strong>Sécurité et confidentialité des données :</strong></p>
      <p>QUERY JURISTE s’engage à mettre en œuvre les mesures techniques et organisationnelles appropriées pour assurer la sécurité et l’intégrité des données à caractère personnel, leur sauvegarde ainsi que le rétablissement de leur disponibilité en cas d’incident physique ou technique. QUERY JURISTE veille également à ce que les personnes autorisées à traiter les données à caractère personnel soient soumises à l’obligation d’en préserver la confidentialité.</p>

      <p><strong>Autres sous-traitants :</strong></p>
      <p>QUERY JURISTE est autorisée à faire appel aux sous-traitants (ci-après « le Sous-traitant ultérieur ») listés en Annexe 1 des Conditions Générales pour mener des activités de traitement spécifiques. En cas de changement dans la liste des Sous-traitants ultérieurs autorisés, QUERY JURISTE informera préalablement et par écrit le Client. Cette information devra indiquer clairement les activités de traitement sous-traitées, l’identité et les coordonnées du Sous-traitant ultérieur. Le Client dispose d’un délai de 15 jours à compter de la date de réception de cette information pour présenter ses objections légitimes et motivées. A défaut de notifications d’objections passé ce délai, le Client sera réputé avoir accepté le recours au Sous-traitant ultérieur.</p>
      <p>Le Sous-traitant ultérieur est tenu de respecter les obligations des Conditions Générales pour le compte et selon les instructions du Client. Il appartient à QUERY JURISTE de s’assurer que le Sous-traitant ultérieur présente les mêmes garanties suffisantes quant à la mise en œuvre de mesures techniques et organisationnelles appropriées de manière à ce que le traitement réponde aux exigences de la Réglementation applicable. Si le Sous-traitant ultérieur ne remplit pas ses obligations en matière de protection des données, QUERY JURISTE demeure pleinement responsable devant le Client de l’exécution par le Sous-traitant ultérieur de ses obligations.</p>

      <p><strong>Assistance et fourniture d’informations :</strong></p>
      <p>QUERY JURISTE s’engage à assister le Client et répondre dans les meilleurs délais à toute demande d’information lui étant adressée par le Client, que ce soit dans le cadre d’une demande d’exercice de leurs droits par les personnes concernées, d’une analyse d’impact, ou d’une demande présentée par les autorités de protection des données ou le délégué à la protection des données du Client.</p>

      <p><strong>Notification des violations de données à caractère personnel :</strong></p>
      <p>QUERY JURISTE s’engage à notifier le Client dans les meilleurs délais après en avoir pris connaissance toute violation des données à caractère personnel et à lui communiquer toute information et documentation utile relative à cette violation.</p>

      <p><strong>Sort des données :</strong></p>
      <p>QUERY JURISTE s’engage à son choix, à supprimer les données à caractère personnel à l’expiration du présent contrat ou à les renvoyer au Client et à ne pas en conserver de copie, sauf si la Réglementation applicable l’exige.</p>

      <p><strong>Documentation :</strong></p>
      <p>QUERY JURISTE met à disposition du Client, sur demande de celui-ci, toutes les informations et tous les documents nécessaires pour démontrer le respect de ses obligations et pour permettre la réalisation d’audits. Le Client a ainsi la possibilité de procéder à des audits une fois par an et à ses frais afin de vérifier la conformité de QUERY JURISTE aux obligations prévues dans le présent article. Le Client informera QUERY JURISTE de la tenue de l’audit moyennant un préavis minimum de 2 semaines. QUERY JURISTE se réserve le droit de refuser l’identité de l’auditeur retenu s’il appartient à une société concurrente. L’audit devra être réalisé pendant les heures ouvrées de QUERY JURISTE et de manière à perturber le moins possible son activité. L’audit ne pourra ainsi porter atteinte de quelque façon que ce soit (i) aux mesures techniques et organisationnelles de sécurité déployées par QUERY JURISTE, (ii) à la sécurité et la confidentialité des données des autres clients de QUERY JURISTE, (iii) ni au bon fonctionnement et à l’organisation de la production de QUERY JURISTE. Dans la mesure du possible, les parties conviendront à l’avance du périmètre de l’audit. Le rapport d’audit sera adressé à QUERY JURISTE afin de permettre à ce dernier de formuler ses observations ou remarques éventuelles par écrit, lesquelles seront annexées à la version finale du rapport d’audit. Chaque rapport d’audit sera considéré comme une information confidentielle.</p>

      <h3>Obligations du Client vis-à vis de QUERY JURISTE</h3>
      <p>Le Client s’engage à :</p>
      <ul>
        <li>fournir à QUERY JURISTE les données personnelles visées dans l’Annexe 1, à l’exclusion de toute donnée personnelle non pertinente, disproportionnée ou non nécessaire, et à l’exclusion de toute donnée « particulière » au sens de la Réglementation applicable, sauf si les traitements le justifient, à charge pour le Client d’établir ces justifications et de prendre toutes mesures, notamment d’information préalable, de recueil de consentement et de sécurité, appropriées pour de telles données particulières ;</li>
        <li>collecter sous sa responsabilité, de manière licite, loyale et transparente, les données personnelles fournies à QUERY JURISTE, pour l’exécution de ses services, et en particulier, s’assurer de la base légale de cette collecte et de l’information due aux personnes concernées ;</li>
        <li>tenir un registre des traitements et plus généralement, respecter les principes issus de la Réglementation applicable ;</li>
        <li>veiller au préalable et pendant toute la durée du traitement, au respect des obligations prévues par la Réglementation applicable.</li>
      </ul>
    </section>

    <section class="cgv-section">
      <h2>Références commerciales</h2>
      <p>Le Client autorise expressément QUERY JURISTE à le citer et à utiliser le cas échéant la reproduction de sa marque ou de son logo à titre de références commerciales, notamment lors de manifestations ou d’événements, dans ses documents commerciaux, sur sa Plateforme et sur son site, sous quelque forme que ce soit, pendant la durée de son inscription et 5 ans après son terme.</p>
    </section>

    <section class="cgv-section">
      <h2>Force majeure</h2>
      <p>QUERY JURISTE ne pourra voir sa responsabilité engagée pour un défaut d’exécution de ses obligations contractuelles si ce défaut est dû à un évènement indépendant de sa volonté et constitutif de force majeure, telle que définie à l’article 1218 du Code civil.</p>
      <p>QUERY JURISTE devra informer le Client dans les meilleurs délais en indiquant la nature du cas de force majeure. Les parties se rapprocheront afin de déterminer ensemble les moyens les plus appropriés pour pallier, si possible, les conséquences du ou des évènement(s) constitutif(s) de la force majeure.</p>
      <p>Si le cas de force majeure perdure plus de 3 mois, le Client pourra résilier son Compte Client, de plein droit, sans formalité judiciaire, sans préavis et sans droit à indemnités de quelque nature que ce soit, par l’envoi d’une lettre recommandée avec avis de réception ayant effet immédiat.</p>
      <p>Si, à la suite d’un cas de force majeure, la partie affectée est empêchée de remplir seulement une partie de ses obligations contractuelles, elle reste responsable de l’exécution des obligations qui ne sont pas affectées par le cas de force majeure ainsi que de ses obligations de paiement.</p>
      <p>Dès cessation du cas de force majeure, la partie empêchée doit informer immédiatement l’autre partie et reprendre l’exécution des obligations affectées dans un délai raisonnable.</p>
    </section>

    <section class="cgv-section">
      <h2>Fin des Services</h2>
      <p>L’Abonnement peut être dénoncé à tout moment par :</p>
      <ul>
        <li>Le Client, en adressant à QUERY JURISTE une demande aux coordonnées mentionnées à l’article « Identification de QUERY JURISTE » ou à travers le Compte Client,</li>
        <li>QUERY JURISTE, en adressant un email au Client.</li>
      </ul>
      <p>Le Client a la possibilité, à tout moment, d’annuler l’Abonnement via son Compte Client.</p>
      <p>Toute Période entamée est due dans son intégralité.</p>
    </section>

    <section class="cgv-section">
      <h2>Sanctions des manquements</h2>
      <p>En cas de manquement à l’une quelconque des dispositions des Conditions Générales, ou plus généralement, d’infraction aux lois et règlements par le Client, QUERY JURISTE se réserve le droit de prendre toute mesure appropriée et notamment de :</p>
      <ul>
        <li>suspendre, supprimer ou empêcher l’accès à la Plateforme et aux Services du Client, auteur du manquement ou de l’infraction, ou y ayant participé,</li>
        <li>supprimer tout contenu en lien avec le manquement ou l’infraction considéré(e), en totalité ou en partie,</li>
        <li>prendre toutes mesures appropriées et engager toute action en justice,</li>
        <li>avertir le cas échéant les autorités compétentes, coopérer avec elles et leur fournir toutes les informations utiles à la recherche et à la répression d’activités illégales ou illicites.</li>
      </ul>
      <p>Le Client est informé et accepte que tout manquement à ses obligations pourra entraîner, outre les conséquences prévues ci-dessus, la fermeture immédiate du Compte Client par QUERY JURISTE, par tout moyen écrit.</p>
    </section>

    <section class="cgv-section">
      <h2>Modifications</h2>
      <p>QUERY JURISTE se réserve la faculté de modifier à tout moment les Conditions Générales. QUERY JURISTE en informera le Client par tout moyen écrit (et notamment par email), en respectant un préavis de 30 jours avant leur date d’entrée en vigueur.</p>
      <p>Les Conditions Générales modifiées sont applicables lors du renouvellement de l’Abonnement du Client.</p>
      <p>Si le Client n’accepte pas les Conditions Générales modifiées, il lui appartient de se désinscrire des Services dans les conditions prévues à l’article « Fin des Services ».</p>
      <p>Si le Client utilise les Services après l’entrée en vigueur de ses Conditions Générales modifiées, QUERY JURISTE considère que le Client les a acceptées.</p>
    </section>

    <section class="cgv-section">
      <h2>Loi applicable et juridiction</h2>
      <p>Les présentes sont régies par la loi française.</p>
      <p>En cas de litige opposant le Client et QUERY JURISTE, et à défaut d’accord amiable dans les 2 mois suivant la première notification, celui-ci sera soumis à la compétence exclusive des tribunaux de Paris (France), sauf dispositions impératives contraires.</p>
    </section>

    <section class="cgv-section annex-section">
      <h2>Annexe 1 – Données Personnelles</h2>
      <p><strong>Description du traitement des données effectué par QUERY JURISTE pour le compte du Client</strong></p>

      <p><strong>Finalités du traitement de données à caractère personnel :</strong> Fournir les Services au Client</p>
      <p><strong>Nature des opérations de traitement :</strong> Accès, collecte, enregistrement, organisation, conservation, extraction, consultation, utilisation, transmission, rapprochement, limitation, effacement, destruction</p>
      <p><strong>Type de données à caractère personnel traitées :</strong> En fonction des instructions du Client</p>
      <p><strong>Catégories de personnes concernées :</strong> Clients du Client</p>
      <p><strong>Durée du traitement :</strong> La durée de fourniture des Services</p>

      <h3>Liste des Sous-traitants ultérieurs autorisés</h3>
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Sous-traitants ultérieurs autorisés</th>
              <th>Activités de traitement sous-traitées</th>
              <th>Localisation des traitements</th>
              <th>Garanties appropriées mises en place en cas de transfert de données hors UE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Scaleway S.A.S.</td>
              <td>Hébergement des bases de données de production, stockage de fichiers, sauvegardes et infrastructure réseau principale.</td>
              <td>Europe (Paris, Amsterdam, Varsovie)</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Google Cloud Platform</td>
              <td>Hébergement du "Backend" (Cloud Run) et traitement des modèles d'IA via Vertex AI.</td>
              <td>Union Européenne</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Microsoft Azure</td>
              <td>Traitement des modèles d'IA générative via Azure Foundry</td>
              <td>Union Européenne</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Zoho Corporation</td>
              <td>Gestion de la relation client (CRM)</td>
              <td>Union Européenne</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>OpenAI Ireland Ltd</td>
              <td>Traitement des requêtes par modèles de langage (inférence IA générative)</td>
              <td>Union Européenne (infrastructure européenne d'OpenAI — résidence des données dans l'UE)</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Elasticsearch B.V.</td>
              <td>Classement de pertinence documentaire (service d'inférence hébergé)</td>
              <td>Union Européenne (Belgique)</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Mistral AI</td>
              <td>Reconnaissance optique de caractères (OCR) des documents importés par l'utilisateur dans l'espace de travail.</td>
              <td>Union Européenne (France)</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
            <tr>
              <td>Stripe Payments Europe Ltd</td>
              <td>Traitement des paiements et gestion des abonnements.</td>
              <td>Irlande (UE)</td>
              <td>Clauses Contractuelles Types (CCT) de la Commission européenne.</td>
            </tr>
            <tr>
              <td>Datadog</td>
              <td>Journalisation, supervision et sécurité de la plateforme (SIEM).</td>
              <td>Union Européenne (Francfort, Paris)</td>
              <td>N/A (Les données restent au sein de l'UE).</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div class="acceptance-box" v-if="showAcceptance">
      <p>En cochant cette case, j'accepte les Conditions Générales d'Utilisation ci-dessus.</p>
      <label class="checkbox-container">
        <input type="checkbox" v-model="acceptedTerms" @change="emitAcceptance">
        <span class="checkmark"></span>
        J'accepte les CGU
      </label>
      <div class="error-message" v-if="validationAttempted && !acceptedTerms">
        Vous devez accepter les Conditions Générales d'Utilisation pour continuer.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditionsUtilisation',
  props: {
    showAcceptance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acceptedTerms: false,
      validationAttempted: false,
      // Date dynamique pour l'affichage, mais il est recommandé
      // de la fixer en dur (string) correspondant à la date réelle de mise en ligne.
      currentDate: new Date().toLocaleDateString('fr-FR')
    }
  },
  methods: {
    emitAcceptance() {
      this.$emit('terms-accepted', this.acceptedTerms);
    },
    validateTerms() {
      this.validationAttempted = true;
      return this.acceptedTerms;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR');
    }
  }
}
</script>

<style scoped>
.cgv-container {
  font-family: 'Roboto', Arial, sans-serif;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  line-height: 1.6;
  background-color: white;
}

.cgv-title {
  text-align: center;
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
  text-transform: uppercase;
}

.cgv-date {
  text-align: center;
  font-style: italic;
  color: #666;
  margin-bottom: 30px;
}

.cgv-section {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.cgv-section h2 {
  color: #2c3e50;
  font-size: 22px;
  margin-top: 25px;
  margin-bottom: 15px;
  border-left: 4px solid #3498db;
  padding-left: 10px;
}

.cgv-section h3 {
  color: #3498db;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}

.cgv-section p {
  margin-bottom: 10px;
  text-align: justify;
}

.cgv-section ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.cgv-section li {
  margin-bottom: 8px;
}

.cgv-section a {
  color: #3498db;
  text-decoration: none;
}

.cgv-section a:hover {
  text-decoration: underline;
}

/* Styles pour la liste des définitions */
.definitions-list li {
    margin-bottom: 15px;
}

/* Styles pour les boîtes d'avertissement */
.warning-box {
  background-color: #fff8f8;
  border-left: 4px solid #e74c3c;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
}

.warning-box p {
  margin: 0;
  color: #c0392b;
  font-weight: 500;
}

/* Styles pour le tableau Annexe 1 */
.table-container {
  overflow-x: auto;
  margin-top: 15px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 14px;
}

.data-table th, .data-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  vertical-align: top;
}

.data-table th {
  background-color: #f2f2f2;
  color: #2c3e50;
  font-weight: bold;
}

.data-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Zone d'acceptation */
.acceptance-box {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px;
  margin-top: 40px;
  border-radius: 4px;
  text-align: center;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  text-align: left;
  max-width: 200px;
  margin: 15px auto;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ddd;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #3498db;
  border-color: #3498db;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.error-message {
  color: #e74c3c;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .cgv-container {
    padding: 15px;
  }

  .cgv-title {
    font-size: 24px;
  }

  .cgv-section h2 {
    font-size: 20px;
  }

  .cgv-section h3 {
    font-size: 16px;
  }
}
</style>
